import React, { useEffect, useState } from "react";
import { Button, Checkbox, Col } from "antd";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { Warehouse } from "../../../../redux/@types";
import { warehousesService } from "../../../../shared/services";
import { useParams } from "react-router-dom";
import Table from "../../../../shared/components/ui/Table";
import { useAssignSauceWharehouse } from "../../hooks";
import { useSauceWarehouses } from "../../hooks/sauceWarehouses/useSauceWarehouses";

interface Props {
  fetchQuery?: any;
}

export const TableWarehouses = ({ fetchQuery: _fetchQuery }: Props) => {
  const { sauce_id } = useParams();
  const { sauceWarehouses, sauceWarehousesInfo } = useSauceWarehouses({
    sauceId: +sauce_id!,
  });
  const { assignSauceWharehouse, removeSauceWharehouse } =
    useAssignSauceWharehouse();

  // Estado para almacenar las bodegas seleccionadas
  const [selectedWarehouseIds, setSelectedWarehouseIds] = useState<Set<number>>(
    new Set()
  );

  useEffect(() => {
    // Opcional: Puedes usar esta lógica si necesitas sincronizar con la información existente
    const activeIds = new Set(
      sauceWarehousesInfo
        .filter((info) => info.status === "active")
        .map((info) => info.warehouse_id)
    );
    setSelectedWarehouseIds(activeIds);
  }, [sauceWarehousesInfo]);

  // Maneja la selección o deselección de bodegas
  const handleCheckboxChange = (warehouseId: number, checked: boolean) => {
    setSelectedWarehouseIds((prev) => {
      const newSelection = new Set(prev);
      if (checked) {
        newSelection.add(warehouseId);
      } else {
        newSelection.delete(warehouseId);
      }
      return newSelection;
    });
  };

  // Maneja la asignación de bodegas seleccionadas al producto
  const handleAssignSelected = async () => {
    const selectedProductsArray = Array.from(selectedWarehouseIds);

    for (const warehouseId of selectedProductsArray) {
      await assignSauceWharehouse({
        sauceId: +sauce_id!,
        warehouseId: +warehouseId!,
      });
    }
    await sauceWarehouses();
    setSelectedWarehouseIds(new Set()); // Opcional: Limpia la selección después de la asignación
  };

  // Maneja la eliminación de bodegas seleccionadas del producto
  const handleRemoveSelected = async () => {
    const selectedProductsArray = Array.from(selectedWarehouseIds);

    for (const warehouseId of selectedProductsArray) {
      await removeSauceWharehouse(+warehouseId!, +sauce_id!);
    }
    await sauceWarehouses();
    setSelectedWarehouseIds(new Set()); // Opcional: Limpia la selección después de la eliminación
  };

  const columns: TableColumns<Warehouse> = [
    {
      title: "ID",
      width: 1,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      width: 2,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Dirección",
      width: 2,
      dataIndex: "address",
      key: "address",
      filterType: "text",
    },
    {
      title: "Seleccionar",
      key: "operation",
      fixed: "right",
      width: 1,
      render: (_, item) => {
        const isChecked = selectedWarehouseIds.has(item.id);

        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Checkbox
              checked={isChecked}
              onChange={(e) => handleCheckboxChange(item.id, e.target.checked)}
            />
          </Col>
        );
      },
    },
  ];

  return (
    <>
      <Button
        type="primary"
        onClick={handleAssignSelected}
        disabled={selectedWarehouseIds.size === 0}
        style={{ marginBottom: 16 }}
      >
        Asignar salsas
      </Button>
      <Button
        type="default"
        onClick={handleRemoveSelected}
        disabled={selectedWarehouseIds.size === 0}
        style={{ marginBottom: 16, marginLeft: 8 }}
      >
        Desasignar salsas
      </Button>
      <Table<Warehouse>
        columns={columns}
        scroll={{}}
        fetchQueryProps={{
          $sort: { id: -1 },
        }}
        service={warehousesService}
      />
    </>
  );
};
